import type { MenuProps } from '@mui/material/Menu';

export const MAX_VISIBLE_OPTIONS = 5;

// MenuItem is 36px tall on desktop; the menu list adds 8px padding top and bottom.
const MENU_ITEM_HEIGHT = 36;
const MENU_LIST_PADDING = 8;

export const limitedMenuProps: Partial<MenuProps> = {
  slotProps: { paper: { sx: { maxHeight: MAX_VISIBLE_OPTIONS * MENU_ITEM_HEIGHT + 2 * MENU_LIST_PADDING } } },
};
